export default "__VITE_ASSET__DvCdFe6B__"